import { FIRE_DEPARTMENT_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Ford County LEPC": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: false,
        },
      },
      includeLepcs: [
        {
          id: "1161",
          name: "Ford County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "KS",
    dependsOn: ["Prior Activity"],
  },
  "Kansas Invoice": {
    parameters: {
      linkUrls: ["http://kansas.tier2online.com/"],
      staffInputs: {
        fees: true,
        documentTypes: {
          certification: true,
          feeCalculation: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Organization",
    state: "KS",
  },
  "Kansas State Portal": {
    parameters: {
      linkUrls: ["http://kansas.tier2online.com/"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "KS",
  },
  "Lenexa Fire Dept Portal": {
    parameters: {
      linkUrls: [
        "https://www.lenexa.com/Business-Development/Businesses/Safety-Requirements/Tier-II-Hazardous-Material-Right-to-Know",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          receipt: false,
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.KS.LENEXA_FIRE_DEPARTMENT,
          name: "Lenexa Fire Dept",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "KS",
    dependsOn: ["Prior Activity"],
  },
  "Kansas City, Kansas Fire Dept Portal": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: false,
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.KS.KANSAS_CITY_KANSAS_FIRE_DEPT,
          name: "Kansas City Kansas Fire Dept",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "KS",
    dependsOn: ["Prior Activity"],
  },
};
